import { UrlParser } from "../modules/url";
export default class Navigation {
    constructor(options) {
        this.options = Object.assign({
            selector: 'nav.main',
            activeClass: 'active',
            dropdownSelector: '.dropdown'
        }, this.options);
        document.addEventListener('DOMContentLoaded', () => { this.init(); });
    }
    init() {
        this.setActive();
    }
    setActive() {
        var navList = document.querySelectorAll(this.options.selector);
        for (var i = 0; i < navList.length; i += 1) {
            var linkList = navList[i].querySelectorAll('li.nav-item');
            var url = new UrlParser(location.href);
            for (var q = 0; q < linkList.length; q += 1) {
                let link = linkList[q].querySelector('a.nav-link');
                let linkUrl = link && link.getAttribute("href") != "" ? link.pathname : "";
                if (linkUrl.toLowerCase() == url.PathName.toLowerCase()) {
                    this.toggleAncestor(linkList[q], true);
                    linkList[q].classList.add(this.options.activeClass);
                }
            }
        }
    }
    toggleAncestor(el, recursive = false) {
        this.options.debug && console.log("toggleAncestor", el, "Recursive: " + recursive);
        var ancestor = el.closest(this.options.dropdownSelector);
        this.options.debug && (ancestor != null ? console.log("Ancestor found: ", ancestor) : console.log("Ancestor not found"));
        if (ancestor !== null) {
            ancestor.classList.add(this.options.activeClass);
            if (recursive) {
                this.toggleAncestor(ancestor.parentElement, true);
            }
        }
    }
}
